
/**
 * Devuelve coordenadas de una ubicación
 */

export async function getCoordinates(name: string, city: string = null): Promise<{ latitude: number | null, longitude: number | null }> {
    return new Promise((resolve, reject) => {
        const geocoder = new google.maps.Geocoder();
        const address = city ? `${name}, ${city}` : name;
        geocoder.geocode({ address: address }, (results: any, status: any) => {
            if (status === google.maps.GeocoderStatus.OK) {
                const latitude = results[0].geometry.location.lat();
                const longitude = results[0].geometry.location.lng();
                resolve({ latitude, longitude });
            } else {
                console.warn("TOOLS: Error al obtener la ubicación:", status);
                resolve(null);
            }
        });
    });
}